import { render, staticRenderFns } from "./newexcel.vue?vue&type=template&id=8751a1f0&scoped=true"
import script from "./newexcel.vue?vue&type=script&lang=js"
export * from "./newexcel.vue?vue&type=script&lang=js"
import style0 from "./newexcel.vue?vue&type=style&index=0&id=8751a1f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8751a1f0",
  null
  
)

export default component.exports